import dayjs from 'dayjs';
import dayjsPluginUTC from 'dayjs/plugin/utc';
import { put, PutEffect } from 'redux-saga/effects';
import { Logout, logOut } from '../actions/loginAndRegisterActions';
import { accessTokenLocalStoragePath, expiresAtLocalStoragePath } from '../constants';

export const authenticated = (): boolean => {
    dayjs.extend(dayjsPluginUTC);
    const token = localStorage.getItem(accessTokenLocalStoragePath);
    const exp = localStorage.getItem(expiresAtLocalStoragePath) || '';
    const expiresTime = dayjs.unix(parseInt(exp));
    const nowTime = dayjs.utc().add(1, 'minute');
    const notExpired = dayjs(expiresTime).isAfter(nowTime);
    return !!exp && notExpired && !!token && token.length > 0;
};
type AuthSagaReturnType = Generator<PutEffect<Logout>, void, void>;

export default function* authSaga(): AuthSagaReturnType {
    try {
        const tokenValid = authenticated();
        if (!tokenValid) {
            yield put(logOut());
        }
    } catch (error) {
        yield put(logOut());
    }
}
